import { Trash2 } from 'lucide-react';

const DraftStatusIndicator = ({ lastDraftTime, draftSaved, colorOverrides, onClearDraft }) => {
  if (!lastDraftTime) return null;

  return (
    <div className="flex items-center gap-2 text-[11px] text-slate-400">
      <div className={`w-1.5 h-1.5 rounded-full ${draftSaved ? 'bg-emerald-500' : 'bg-slate-300'}`} />
      <span>Lagra {lastDraftTime.toLocaleTimeString('nb-NO', { hour: '2-digit', minute: '2-digit' })}</span>
      {Object.keys(colorOverrides).length > 0 && (
        <span className="text-blue-500">{Object.keys(colorOverrides).length} fargar</span>
      )}
      <button onClick={onClearDraft} className="text-slate-400 hover:text-red-500 transition-colors ml-1" title="Fjern draft">
        <Trash2 className="w-3 h-3" />
      </button>
    </div>
  );
};

export default DraftStatusIndicator;
